import type { ReactElement } from 'react';
import { skeletonLine } from '@/components/ui/skeleton';

// Skeletons contextuales con la forma real de cada pestaña (UX-LOAD-01), no un spinner.

/** Lista de avisos: punto, asunto, cuerpo y fecha. */
export function InboxSkeleton(): ReactElement {
  return (
    <ul className="notices" aria-busy="true" aria-label="Cargando avisos">
      {Array.from({ length: 4 }).map((_, i) => (
        <li key={i} className="notice">
          <span className="udot" aria-hidden="true" />
          <div className="nbody">
            <div className={skeletonLine({ width: 50 })} />
            <div className={skeletonLine({ width: 80, space: 'top' })} />
            <div className={skeletonLine({ width: 'md', space: 'top' })} />
          </div>
        </li>
      ))}
    </ul>
  );
}

/** Configuración: tabla de reglas a la izquierda y tarjetas a la derecha. */
export function SettingsSkeleton(): ReactElement {
  return (
    <div className="g-2" aria-busy="true" aria-label="Cargando configuración">
      <div className="card rise d1">
        <div className="ch">
          <h3>Reglas de notificación</h3>
        </div>
        <div className="cb">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className={skeletonLine({ width: 90, space: 'y' })} />
          ))}
        </div>
      </div>
      <div className="stack">
        {['Escalamiento automático', 'Plazos por etapa'].map((title) => (
          <div key={title} className="card rise d2">
            <div className="ch">
              <h3>{title}</h3>
            </div>
            <div className="cb">
              <div className={skeletonLine({ width: 70 })} />
              <div className={skeletonLine({ width: 50, space: 'top' })} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
